import { useEffect, useState } from 'react';

const navItems = [
  { label: '首页', href: '#top' },
  { label: '作品浏览', href: '#browse' },
  { label: '排行榜', href: '#ranking' },
  { label: '更新时间表', href: '#schedule' },
  { label: '观看指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 border-b ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-background-200'
          : 'bg-background-50/70 backdrop-blur border-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="h-16 flex items-center justify-between">
          <a href="#top" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-flower-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-semibold text-foreground-950 whitespace-nowrap">
              樱花动漫在线
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-3 py-2 text-sm text-foreground-700 rounded-md transition-colors hover:text-primary-700 hover:bg-primary-50 whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#browse"
              className="hidden md:inline-flex items-center gap-1 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-play-circle-line"></i>
              立即观看
            </a>
            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-line text-lg'}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-2 py-2.5 text-sm text-foreground-700 rounded-md transition-colors hover:text-primary-700 hover:bg-primary-50"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#browse"
              onClick={() => setMenuOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium"
            >
              <i className="ri-play-circle-line"></i>
              立即观看
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}